import {
  type UseQueryOptions,
  type UseQueryReturnType,
  useQuery,
} from '@tanstack/vue-query'
import type { MaybeRef } from '@vueuse/core'
import { TanStackQueryIds } from '../query-ids'
import { getElementalTags } from '~~/src/api/tags'
import type { GetReturn } from '~~/src/types/utils'

export const useElementalTagsQuery = (
  args: {
    elementalId?: MaybeRef<string | null | undefined>
  },
  options?: Omit<
    UseQueryOptions<
      GetReturn<typeof getElementalTags>,
      Error
    >,
    'queryKey' | 'queryFn' | 'placeholderData' | 'keepPreviousData'
  >,
): UseQueryReturnType<GetReturn<typeof getElementalTags>, Error> => {
  return useQuery({
    queryKey: [TanStackQueryIds.ELEMENTAL_TAGS, args.elementalId] as const,
    queryFn: async ({ queryKey }) => {
      const [_, elementalId] = queryKey
      if (!elementalId)
        return []
      return await getElementalTags(elementalId)
    },
    ...options,
  })
}
